import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

function initContentCardCarousel() {
  const carouselElements = document.querySelectorAll('.content-card-carousel');

  if (carouselElements.length === 0) return;

  carouselElements.forEach((el) => {
    const swiperEl = el.querySelector('.swiper');

    if (!swiperEl) {
      return;
    }

    try {
      const btnNext = el.querySelector('.swiper-button-next');
      const btnPrev = el.querySelector('.swiper-button-prev');

      const swiper = new Swiper(swiperEl, {
        spaceBetween: 16,
        modules: [Navigation],
        navigation: {
          nextEl: btnNext,
          prevEl: btnPrev,
        },
        loop: false,
        slidesPerView: 'auto',
        on: {
          init: (swiper) => {
            updateControlsVisibility(el, swiper);
            updateButtonStates(btnPrev, btnNext, swiper);
          },
          slideChange: (swiper) => {
            updateButtonStates(btnPrev, btnNext, swiper);
          },
          lock: (swiper) => {
            updateControlsVisibility(el, swiper);
          },
          unlock: (swiper) => {
            updateControlsVisibility(el, swiper);
          },
        },
      });
    } catch (error) {
      console.error('Failed to initialize content card carousel:', error);
    }
  });
}

function updateControlsVisibility(el, swiper) {
  const controls = el.querySelector('.swiper-controls');
  if (controls) {
    controls.style.display = swiper.isLocked ? 'none' : '';
    controls.style.opacity = swiper.isLocked ? '0' : '1';
  }
}

function updateButtonStates(btnPrev, btnNext, swiper) {
  if (btnPrev) {
    btnPrev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
    btnPrev.disabled = swiper.isBeginning;
  }
  if (btnNext) {
    btnNext.classList.toggle('swiper-button-disabled', swiper.isEnd);
    btnNext.disabled = swiper.isEnd;
  }
}

window.addEventListener('DOMContentLoaded', initContentCardCarousel);
